import {sqftPost} from "./sqftApi";
import sqftConfig from "../components/canvas/store/sqftConfig";

const LOCAL_COMPOSER_URL = "http://127.0.0.1:8120";
const STAGE_COMPOSER_URL = "https://quotekandb.com";

const getComposerDomain = () => {
  if (sqftConfig.isLocalComposerMode()) return LOCAL_COMPOSER_URL;
  if (sqftConfig.threeD.useStagingDomain) return STAGE_COMPOSER_URL;
  return null;
};

export default class SqftJsonApi {
  static postCabinetSet(data, options = {}) {
    return sqftPost("/api/AR/Composer", data, {...options, domain: getComposerDomain()});
  }

  static getCountertops(data, options = {}) {
    return sqftPost("/api/AR/Composer/countertop", data, {...options, domain: getComposerDomain()});
  }

  static getResizedCabinet(data, options = {}) {
    return sqftPost("/api/AR/Composer/cabinet_resize", data, {...options, domain: getComposerDomain()});
  }

  static getResizedCornerCabinet(data, options = {}) {
    return sqftPost("/api/AR/Composer/corner_cabinet_resize", data, {...options, domain: getComposerDomain()});
  }

  static getWall(data, options = {}) {
    return sqftPost("/api/AR/Composer/wall", data, {...options, domain: getComposerDomain()});
  }

  static saveFiles(data, options = {}) {
    return sqftPost("/api/AR/Store", data, {...options, domain: getComposerDomain()});
  }

  static getCrownMolding(data, options = {}) {
    return sqftPost("/api/AR/Composer/crown_molding", data, {...options, domain: getComposerDomain()});
  }
}
